import { createFileRoute } from '@tanstack/react-router';
import { RecurringJobsSettings } from '@/components/settings/contracts/RecurringJobsSettings';

/**
 * Recurring jobs settings — a single page: the contract lifeline plus the six
 * moments, read-only until Edit. Replaces the old per-tab sprawl (the tab
 * routes now redirect here).
 */
export const Route = createFileRoute('/_dashboard/dashboard/settings/contracts/')({
  component: RecurringJobsSettings,
});
